import { render, staticRenderFns } from "./GasbotImageHeader.vue?vue&type=template&id=42c8c83b&scoped=true"
import script from "./GasbotImageHeader.vue?vue&type=script&lang=ts"
export * from "./GasbotImageHeader.vue?vue&type=script&lang=ts"
import style0 from "./GasbotImageHeader.vue?vue&type=style&index=0&id=42c8c83b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8c83b",
  null
  
)

export default component.exports